let windowHost = window.location.host;
let appHostName = 'https://elkana.org.ge';
if (windowHost === 'localhost:3000') {
    appHostName = 'http://local-elkana';
}
export const REMOTE_HOST_URL = appHostName;
